export default __webpack_public_path__ + "static/media/bike-nav-completed.b31b48b2.svg";